/* eslint-disable react-hooks/exhaustive-deps */
'use client'

import { useStoreContext } from '@/context/StoreContext'
import getSelectedFilters from '@/useCases/filters/getSelectedFilters'
import { sendScreenViewEventSSR } from '@mercadoni/sinister/dist/cjs/monitors'
import { useHeaderDataContext } from '@mercadoni/sinister/dist/cjs/shared/contexts'
import { useEffect } from 'react'
import { AnalyticsSearchLoadProps } from '~types/search'
import useGetSearchEvents from '../analytics/useGetSearchEvents'

const AnalyticsSearchLoad = ({
  totalProducts = 0,
  products,
  pagination,
}: AnalyticsSearchLoadProps) => {
  const { filtersPathInfo, clientId, version, screenNames } =
    useHeaderDataContext()
  const { store } = useStoreContext()
  const {
    sendSearchTermEvent,
    sendViewSearchResultsEvent,
    sendSearchResultsEvent,
  } = useGetSearchEvents()

  useEffect(() => {
    const hasValidSearchResults =
      totalProducts &&
      totalProducts > 0 &&
      products &&
      products.length > 0 &&
      pagination

    if (hasValidSearchResults) {
      sendSearchResultsEvent({
        searchValue: filtersPathInfo?.searchTerm,
        resultsNumber: totalProducts,
      })
      sendViewSearchResultsEvent({
        searchTerm: filtersPathInfo?.searchTerm,
        resultsNumber: totalProducts,
        products,
        pagination,
        customParams: getSelectedFilters(filtersPathInfo),
      })
    }
    sendSearchTermEvent({
      searchTerm: filtersPathInfo?.searchTerm,
      resultsNumber: totalProducts,
      customParams: getSelectedFilters(filtersPathInfo),
    })
    sendScreenViewEventSSR({
      clientId,
      store,
      version,
      screenName: screenNames['/search']?.screenName ?? '',
    })
  }, [])

  return null
}

export default AnalyticsSearchLoad
